// extracted by mini-css-extract-plugin
export default {"container":"highlightContainer_container__SgnFb"};